import React from 'react';
import styled from 'styled-components';

const ImageContainer = styled.div`
  min-height: 120px;

  width: 325px;
  border: 1px dashed gray;
  background-color: #e8e9eb;
  height: 120px;
  display: flex;
  align-items: center;
  color: #6d6e70;
  font-weight: 300;
  img,
  h3 {
    margin: auto;
    max-width: 80%;
    max-height: 100px;
  }
`;
export const UploadImage = ({ input }) => {
  return (
    <ImageContainer>
      {input.value ? (
        <img src={input.value} alt={'banner-logo'} />
      ) : (
        <h3>Click to Upload </h3>
      )}
    </ImageContainer>
  );
};
